import React, { useCallback, useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { DataRoomMemberStats } from 'router/subrouters/DataRoom/models/DataRoom';
import BuyAcessTable from 'router/subrouters/DataRoom/components/BuyAcessTable';
import DashCardHeading from '../DashCardHeading';
import { useTranslation } from 'react-i18next';
import DashEmptyState from '../DashEmptyState';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

import './DashMembers.styles.scss';

type DashMembersProps = {
  className?: string;
};

const DashMembers: React.FC<DashMembersProps> = (props) => {
  const { className } = props;

  const [membersStats, setMembersStats] = useState<DataRoomMemberStats>();
  const [areMembersStatsLoading, setAreMembersStatsLoading] = useState(true);

  const {
    dataRoom: { _id: dataRoomId },
  } = useContext(DataRoomContext);
  const { popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const isNotEmpty = !!membersStats?.buySide || areMembersStatsLoading;

  const classes = classNames('dash-members', 'card', 'white-panel', className, {
    'stat-card': isNotEmpty,
  });

  const renderTile = useCallback(
    (stat: number, label: string) => (
      <div>
        {!areMembersStatsLoading && (
          <>
            <p>{stat}</p>
            <p>{t(label)}</p>
          </>
        )}
      </div>
    ),
    [areMembersStatsLoading, t],
  );

  useEffect(() => {
    (async () => {
      try {
        setAreMembersStatsLoading(true);
        const { data } = await dataRoomApi.room.getMemberStats(dataRoomId);

        setMembersStats(data);
      } catch (e) {
        popServerError(e);
      } finally {
        setAreMembersStatsLoading(false);
      }
    })();
  }, [dataRoomId, popServerError]);

  return (
    <div className={classes}>
      {isNotEmpty ? (
        <>
          <DashCardHeading
            heading={t('members')}
            linkLabel={t('members')}
            linkTo="../members"
          />
          <div className="stat-tiles">
            {renderTile(membersStats?.buySide, 'buySide')}
            {renderTile(membersStats?.sellSide, 'sellSideColleagues')}
          </div>
          <BuyAcessTable />
        </>
      ) : (
        <DashEmptyState
          title={t('inviteAndManageMembers')}
          link={{ label: t('manageMembers'), to: '../members' }}
        />
      )}
    </div>
  );
};

export default DashMembers;
